// 고유한 uuid생성
export const uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

// base64로 된 문자열 디코딩
export const jsonObjFromBase64 = (base64) => {
  const jsonString = decodeURIComponent(atob(base64));
  return JSON.parse(jsonString);
};
